<template>
  <div id="profileFoodDiary">
    <mu-card id="diary">
      <mu-card-header class="headerTitle">
        <mu-float-button class="direction back" icon="chevron_left" mini @click="filterDiaryByDay('back')" :disabled="isLoading" />
        <span class="title" v-text="formatDate(date, 'dddd, MMMM Do YYYY')"></span>
        <span class="title mobileDate" v-text="formatDate(date, 'MMM Do YY')"></span>
        <mu-float-button class="direction next" icon="chevron_right" mini @click="filterDiaryByDay('next')" :disabled="isLoading || isToday" />
      </mu-card-header>
      <mu-content-block class="loader" v-if="isLoading">
        <mu-circular-progress :size="40" />
      </mu-content-block>
      <div class="tabs" v-if="!isLoading && hasFoods">
        <mu-tabs :value="activeTab" @change="setActiveTab">
          <mu-tab v-for="tab, tabindex in tabs" :value="tab.label" :title="tab.label" :key="`tab-${tabindex}`" />
        </mu-tabs>
        <mu-divider />
        <food-dairy-tab v-for="tab, tabindex in tabs" :userId="userId" @onDelete="onDeleteFood" v-if="activeTab === tab.label" :tab="tab.label" :foods="filterDiaryBy('meal_types', tab.label)" :recipes="filterRecipeDiaryBy('meal_types', tab.label)" :totals="filterDiaryBy('totals', tab.label)" :key="`tab-${tabindex}`" />
      </div>
      <div class="noFoods" v-if="!isLoading && !hasFoods">
        <p>No foods have been added for this day.</p>
      </div>
    </mu-card>
  </div>
</template>
<script>

  import FoodApi from '../../../api/Food';
  import FoodDairyTab from "./FoodDiaryTab.vue";
  import './FoodDiary.less';
  export default {
    components: {
      FoodDairyTab
    },
    props: {
      userId: {
        type: Number,
        required: true
      }
    },
    name: 'food-diary',
    data() {
      return {
        isLoading: false,
        date: null,
        formatDateAs: 'YYYY-MM-DD',
        activeTab: 'All',
        tabs: [
          { label: 'All' },
          { label: 'Breakfast' },
          { label: 'Lunch' },
          { label: 'Dinner' },
          { label: 'Snack' },
        ],
        diary: {},
      }
    },
    methods: {
      onDeleteFood(food) {
        let self = this;
        self.loadFoodByDay();
      },
      loadFoodByDay() {
        let self = this;
        self.isLoading = true;
        FoodApi.getFoodWithDate(self.date, self.userId).then(response => {
          self.diary = response.data;
          self.isLoading = false;
          // go back to All tab
          self.setActiveTab('All');
        }).catch(error => {
          self.$toastr.error('Error loading your diary');
        });
      },
      initMounted() {
        let self = this;
        // store NOW day
        self.date = self.getNowDate();
        // load foods
        self.loadFoodByDay();
      },
      getNowDate() {
        let self = this;
        // get current date
        return moment().format(self.formatDateAs);
      },
      filterDiaryByDay(direction) {
        let self = this, newDate = null;
        if( direction === 'next' ) {
          // plus a day from selected date
          newDate = moment(self.date).add('1', 'days').format(self.formatDateAs);
        }
        if ( direction === 'back' ) {
          // miuns a day from selected date
          newDate = moment(self.date).subtract('1', 'days').format(self.formatDateAs);
        }
        // set new date based on direction
        self.date = newDate;
        // load foods
        self.loadFoodByDay();
      },
      formatDate(date, format) {
        return moment(date).format(format);
      },
      setActiveTab(tab) {
        let self = this;
        self.activeTab = tab;
      },
      filterDiaryBy(type, tab) {
        let self = this, data = null;
        // lowercase tab
        tab = tab.toLowerCase();
        if ( type === 'meal_types' ) {
          // find meal_types by tab
          data = self.diary.foods.meal_types[tab];
        }
        if ( type === 'totals' ) {
          // find total by tab
          data = self.diary.totals[tab];
        }
        // return data
        return data;
      },
      filterRecipeDiaryBy(type, tab) {
        let self = this, data = null;
        // lowercase tab
        tab = tab.toLowerCase();
        if ( type === 'meal_types' ) {
          // find meal_types by tab
          data = self.diary.recipes[tab];
        }
        // return data
        return data;
      },
    },
    computed: {
      hasFoods() {
        let self = this;
        return self.diary.total > 0 || self.diary.recipes.all.length > 0;
      },
      isToday() {
        let self = this;
        return moment(self.date).isSame(moment(), 'day');
      },
    },
    mounted() {
      let self = this;
      // init
      self.initMounted();
    }
  }
</script>



// WEBPACK FOOTER //
// FoodDiary.vue?2c2a7600